import type { ThemeWithoutTokens } from '../theme.types';

export const fileInputTokens = (theme: ThemeWithoutTokens) =>
  ({
    fileNameTextColor: theme.colors.body.text,
    fileNameBackgroundColor: theme.palette.grey100,
    fileNameBorderRadius: theme.radiuses.m,
    fileNamePaddingX: theme.space.component.x.s,
    fileNamePaddingY: theme.space.component.y.s,
    // disabled
    fileDisabledNameTextColor: theme.palette.grey400,
    // error
    fileNameErrorBackgroundColor: theme.colors.danger.alpha,
    fileNameErrorIconColor: theme.colors.danger.normal,
    // validate
    fileNameValidIconColor: theme.colors.success.normal,
  }) as const;
